
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import RoutesComponent from './components/RoutesComponent ';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ChannelPartnerAuthProvider } from './context/ChannelPartnerAuthContext';
import { CounsellorAuthProvider } from './context/CounsellorAuthContext';
import { SkillProviderAuthProvider } from './context/SkillProviderAuthContext';
import { SchoolAuthProvider } from './context/SchoolAuthContext';
import { ToastProvider } from './hook/useToast';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {

  const darkTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#555555",
      },
    },
    typography: {
      fontFamily: "Montserrat", // Set Montserrat as the default font

    },
    input: {
      Padding: '0px'
      
    }
  });
  return (
    <>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={darkTheme}>
        <ToastProvider>
          <CssBaseline />
          <AuthProvider>
            <AdminAuthProvider>
              <CounsellorAuthProvider>
                <SkillProviderAuthProvider>
                  <ChannelPartnerAuthProvider>
                    <SchoolAuthProvider>
                      <RoutesComponent></RoutesComponent>
                    </SchoolAuthProvider>
                  </ChannelPartnerAuthProvider>
                </SkillProviderAuthProvider>
              </CounsellorAuthProvider>
            </AdminAuthProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
      </GoogleOAuthProvider>
    </>
  )
}

export default App
